import { render, staticRenderFns } from "./SelectTenantCard.vue?vue&type=template&id=51fe1a22"
import script from "./SelectTenantCard.vue?vue&type=script&lang=js"
export * from "./SelectTenantCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports